import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const DisjointExpandIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 16)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M15 4.8V1h-3.8M15 1l-4.2 4.2M1.1 11.2V15H5M1 15l4.2-4.2" />
    </SVG>
  );
};
